<template>
<section>
    <div id="organizations" class="organizations">
        <div class="container">
            <div class="row row-cols-auto">
                <div class="col-4 col-md-auto text-center" v-for="(item,index) in data" :key="index">
                    <div class="item">
                        <img style="max-width: 100%" :src="require(`@/assets/${item.imagePath}`)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
    export default {
     props:{
         data:{
             type:Array
         }
     }

    };
</script>

<style scoped>
    .organizations {
        width: 100%;
        background: #fff;
        margin:30px 0;
        text-align:center !important; 
    }

        .organizations .item {
            width: 100%;
            height: 100px;
            text-align: center;
            overflow: hidden;
            margin: 10px auto;
        }

            .organizations .item img {
                width: 100px;
                height: 100px;
                border-radius: 100%;
                padding: 20px;
                border: #ddd solid 1px;
                filter: grayscale(100%);
                transition: all .5s;
            }

                .organizations .item img:hover {
                    filter: unset;
                }

</style>

